<template lang="pug">
  .lessons-list.pl-3
    h2 {{ date | dp('d MMMM') }}

    template(v-if="!lessons.length && isTeacher && !this.$route.meta.trained")
      p Добавьте свой первый урок:
      ul
        li выберите тему из списка;
        li выберите урок;
        li выберите одну или несколько групп, для которых будет проводиться урок;
        li настройте основные параметры конференции: дату, продолжительность и приватность.
    template(v-else)
      v-list(nav)
        v-list-item.sdo-card-block.my-3.px-5(
          v-for="(i, idx) in lessons"
          :key="i.id"
        )
          v-list-item-content
            v-list-item-title
              strong {{ idx + 1 }} урок
            v-list-item-title  {{ i.courseTitle }}
            v-list-item-subtitle.mb-3.caption {{ $conf.LESSON_TYPE_NAMES[i.type] }}
            v-list-item-subtitle Начало {{ i.date_start | dp('HH:mm') }}
            v-list-item-subtitle Окончание {{ i.date_end | dp('HH:mm') }}
          //- v-list-item-action
          //-   v-btn(
          //-     v-if="isTeacher && !$route.meta.trained"
          //-     color="secondary"
          //-     title="Редактировать урок"
          //-     fab
          //-     depressed
          //-     small
          //-   )
          //-     v-icon(v-if="isTeacher && !$route.meta.trained") mdi-pencil

    .row.ma-0
      v-btn.my-3(
        text
        outlined
        rounded
        @click="$emit('open-calendar')"
      ) Закрыть

      v-btn.ml-2.my-3(
        v-if="isTeacher && !this.$route.meta.trained"
        color="secondary"
        rounded
        :to=`{
          name: 'ConferenceCreate',
          query: {
            date,
          }
        }`
      ) Добавить видеотрансляцию
</template>

<script>
export default {
  name: 'LessonsList',
  props: {
    course: { type: Object, default: null },
    date: { type: String, default: null },
    lessons: { type: Array, default: () => ([]) },
    isTeacher: { type: Boolean, required: true },
  },
};
</script>
